/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 01.06.2016
 *
 */

import { Client } from 'external/lwr-client';
import { ApiUtil } from 'plugin/liferay-widgets-react-web';
import ClassNames from '../constants/ClassNames';

const className = ClassNames.LogicalLayer;


const logicalLayerService = (m, o) => Client.invoke('/map.logicallayer/' + m, o);
const logicalLayerServiceWithContext = (m, o, c) => Client.invokeWithContext('/map.logicallayer/' + m, o, c);


const api = {

    listGroupLogicalLayers(query) {
        return logicalLayerServiceWithContext('list-by-group-scope.3', {
            start: query.start,
            end: query.end
        }, {});
    },

    listViewableLogicalLayersByGroupScope() {
        return logicalLayerServiceWithContext('list-viewable-by-group-scope.1', {});
    },

    get(logicalLayer) {
        return logicalLayerService('get.1', {
            id: logicalLayer.id
        });
    },

    addLogicalLayer(logicalLayer) {
        return ApiUtil.apiCall(logicalLayerServiceWithContext('add.1', {}, {
            title: logicalLayer.title,
            description: logicalLayer.description
        }), {
            className,
            eventType: 'POST'
        });
    },

    updateLogicLayer(logicalLayer) {
        return ApiUtil.apiCall(logicalLayerServiceWithContext('update.2', {
            id: logicalLayer.id
        }, {
            title: logicalLayer.title,
            description: logicalLayer.description
        }), {
            className,
            classPK: logicalLayer.id,
            eventType: 'PUT'
        });
    },

    deleteLogicalLayer(logicalLayer) {
        return ApiUtil.apiCall(logicalLayerServiceWithContext('delete.2', {
            id: logicalLayer.id
        }, {}), {
            className,
            classPK: logicalLayer.id,
            eventType: 'DELETE'
        });
    }
};

ApiUtil.namedApi('LogicalLayerWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/LogicalLayerWebApi.js